import { useYoudao } from "@/hooks/useTranslator";
import { sanitize } from "@/utils/sanitize.util";
import {
  autoHighlightKeyword,
  parsePubmedArticleTitle,
} from "@/utils/string.util";
import Link from "next/link";
import React from "react";
import CheckBox from "../CheckBox";
import TranslateButton from "../TranslateButton";
import styles from "./styles.module.less";

const { title, container } = styles;

interface IProps {
  ePmid: string;
  articleTitle: string;
  term: string;
  verbose: boolean;
  index: number;
}

const Title: React.FC<IProps> = ({
  ePmid,
  articleTitle,
  term,
  verbose,
  index,
}) => {
  const { getTargetYoudao } = useYoudao();
  return (
    <div className={container}>
      <span>
        <CheckBox className={styles.checkbox} verbose={verbose} id={ePmid} />
        <Link href="/navigator/paper/[id]" as={`/navigator/paper/${ePmid}`}>
          <a
            className={title}
            dangerouslySetInnerHTML={{
              __html: `${index + 1}. ${
                parsePubmedArticleTitle(
                  sanitize(getTargetYoudao(ePmid)?.title)
                ) ||
                parsePubmedArticleTitle(
                  sanitize(autoHighlightKeyword(articleTitle, term))
                )
              }`,
            }}
          />
        </Link>
        <TranslateButton id={ePmid} />
      </span>
    </div>
  );
};

export default Title;
